import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export class MarketingWorkFileCard extends HasProjectMixin(Model) {

  declare id: number;
  declare workFile: number;
  declare order: number;
  declare heading: string;
  declare subHeading: string | null;
  declare bodyText: string | null;
  declare assets: number[];

  static get $name() {
    return "MarketingWorkFileCard";
  }

  static get fields() {
    return [
      "id",
      { name: "workFile", dataSource: "work_file", type: "number" },
      { name: "order", type: "number", defaultValue: 0 },
      "heading",
      { name: "subHeading", dataSource: "sub_heading" },
      { name: "bodyText", dataSource: "body_text" },
      "assets",
    ];
  }

  get assetRecords() {
    if (this.project && this.assets?.length) {
      const assetStore = this.project.getCrudStore(STORE_KEYS.marketingAssetStore);
      return this.assets.map((id: number) => assetStore?.getById(id)).filter(Boolean);
    }
    return [];
  }

  get workFileRecord() {
    return this.project?.getCrudStore(STORE_KEYS.marketingWorkfileStore)?.getById(this.workFile);
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingWorkFileCard.exposeProperties();
